import { ISaveAsPatchState } from './saveAsPatchModalContext';
import { SaveAsPatchActionTypes, TSaveAsPatchAction } from './saveAsPatchModalActions';

export const saveAsPatchReducer = (state: ISaveAsPatchState, action: TSaveAsPatchAction): ISaveAsPatchState => {
	switch (action.type) {
		case SaveAsPatchActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case SaveAsPatchActionTypes.SET_TYPE_OF_CHANGES:
			return {
				...state,
				typeOfChanges: action.payload.typeOfChanges,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case SaveAsPatchActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case SaveAsPatchActionTypes.SET_PROPERTIES:
			return {
				...state,
				selectedProperties: action.payload.selectedProperties,
			};
		case SaveAsPatchActionTypes.TOGGLE_FORCE_DISABLE:
			return {
				...state,
				forceDisable: !state.forceDisable,
			};
		case SaveAsPatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case SaveAsPatchActionTypes.RESET_FIELDS:
			return {
				...state,
				typeOfChanges: 'basedChanges',
				IDsSelectedRestaurant: [],
				forceDisable: false,
				selectedProperties: [],
			};
		default:
			return state;
	}
};
